function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时

    let endTimeG

    function cutDownTime() {
      let nowTime = new Date()
      let endTime = new Date(endTimeG)

      let leftTime = endTime.getTime() - nowTime.getTime()
      let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
        leftM = Math.floor((leftTime / (1000 * 60)) % 60),
        leftS = Math.floor((leftTime / 1000) % 60)
      leftH = leftH >= 10 ? leftH : '0' + leftH
      leftM = leftM >= 10 ? leftM : '0' + leftM
      leftS = leftS >= 10 ? leftS : '0' + leftS

      return {
        hour: leftH,
        minute: leftM,
        second: leftS,
      }
    }

    function getCutDownTime() {
      let rHour = 10000000

      let curTime = new Date()
      endTimeG = curTime.setHours(curTime.getHours() + rHour)

      setInterval(function () {
        let cutDownTimeText = cutDownTime()
        $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
        $('.sp_top_cut_down .sp_left_view .sp_minute').html(
          cutDownTimeText.minute
        )
        $('.sp_top_cut_down .sp_left_view .sp_second').html(
          cutDownTimeText.second
        )
      }, 1000)
    }

    getCutDownTime()
    var swiper = new Swiper('.mySwiper', {
      direction: 'vertical',
      spaceBetween: 20,
      // slidesPerView: 4.6,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      // 当前页居中显示
      centeredSlides: true,
      // 第一张和最后一张贴合边缘
      centeredSlidesBounds: true,
    })
    var swiper2 = new Swiper('.mySwiper2', {
      effect: 'fade',
      thumbs: {
        swiper: swiper,
      },
      // autoplay: true,
      // autoplay: {
      //   disableOnInteraction: false,
      // },
      loop: true,
      // initialSlide: 1,
      on: {
        slideChange: function () {
          if (this.activeIndex == 1) {
            // $('#color .option')
            //   .eq(0)
            //   .addClass('active')
            //   .siblings()
            //   .removeClass('active')
          } else if (this.activeIndex > 1) {
            $('#color .option')
              .eq(this.activeIndex - 2)
              .addClass('active')
              .siblings()
              .removeClass('active')
          }
        },
      },
    })
    $('.close-btn').click(function () {
      $('.mask').hide()
    })
    // 数字框
    let prods = window.product
    function getCur(){
      let color = $('#color div.active').attr('data-val')
      let size = $('#Size div.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('.sp-part1-title .sp-save .price1').html(price)
      $('.sp-part1-title .sp-save .price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".sp-part1-title .sp-save .off_box span").html(off_font);
    }
    $('.buyNow').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })
    // 弹窗 图片
    $('.sp-large').click(function () {
      var index = swiper2.realIndex
      $('.mask').css('display', 'flex')
      if (index > 0) {
        $('.mask .img-pop .sp-img').show()
        $('.mask .img-pop .sp-img')[0].src =
          'https://cdn.shopifycdn.net/s/files/1/0786/5801/1441/files/2024081-part1-' + index + '.png'
        $('.mask video').hide()
      } else {
        $('.mask video').show()
        $('.mask .img-pop .sp-img').hide()
      }
      $('.mask .img-pop').css('display', 'flex')
      $('.mask .size-pop').css('display', 'none')
    })
    // 弹窗
    // 选择
    $('.btn-group ul li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      var index = $(this).index()
      $('.size-pop-content .sp-size-table').hide()
      $('.size-pop-content .sp-size-table').eq(index).show()
    })
    $('.size-wrap').click(function () {
      $('.mask').css('display', 'flex')
      $('.mask .size-pop').css('display', 'block')
      $('.mask .img-pop').css('display', 'none')
    })
    $('.img-pop').click(function () {
      $('.mask').hide()
    })
    $('.close-pop').click(function () {
      $('.mask').hide()
    })
    $('.mask').click(function (e) {
      if ($(e.target).closest('.mask .btn').length > 0) {
      } else {
        // $(".mask").hide();
      }
    })
    // our 弹窗
    $('.sp-our').click(function () {
      $('.alert').css('display', 'flex')
    })
    $('.alert-close').click(function () {
      $('.alert').hide()
    })
    $('.option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      changePrice()
    })

    // style选项
    let typeOptions = $('#color .option')
    let img0 = $('.p-img')

    // 切换选项
    function checkType(index) {
      swiper2.slideToLoop(index + 1, 1000, false)
    }

    typeOptions.click(function () {
      let index = $(this).index()
      checkType(index)
    })

    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    $('.product-part .cart-btn').click(function () {
       if (swiper2.realIndex == 0) {
        return
      }
      if (swiper2.realIndex > 0) {
        var indes = swiper2.realIndex
        console.log(swiper2.realIndex)
        var img = $(
          '<img src="https://cdn.shopifycdn.net/s/files/1/0786/5801/1441/files/2024081-part1-' + indes + '.png" alt="">'
        )
      }
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
          });
        },
        dataType: "json",
      });

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '9999',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
          'z-index': '9999',
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $('.sp-header-top .sp-cart').addClass('sp-shake')
              setTimeout(function () {
                $('.sp-header-top .sp-cart').removeClass('sp-shake')
              }, 400)
              $(this).detach()
            }
          )
        }
      )
    })
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop -
          $('.sp-header-top').height() -
          $('.time-part').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
